<template>
  <div class="mensageria-module">
    <p class="mb-3">
      Painel administrativo de Mensageria (estatísticas e modelos da
      plataforma).
    </p>
    <router-link class="btn btn-sm btn-primary" to="/mensageria/admin">
      Abrir painel Mensageria
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Mensageria',
}
</script>
